import PropTypes from 'prop-types'
import React from "react"
import SweetAlert from "react-bootstrap-sweetalert"
import { useTranslation } from 'react-i18next'

export const ConfirmRemoveRole = (props) => {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <SweetAlert
                warning
                title={t("security.roles.confirmRemove_title")}
                onConfirm={() => props.onConfirm(props.roleId)}
                onCancel={() => { props.onClose() }}
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="info"
                confirmBtnText={t("buttons.yes")}
                cancelBtnText={t("buttons.no")}
                showCancel
            >
            </SweetAlert>
        </React.Fragment>
    );
}

ConfirmRemoveRole.propTypes = {
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    roleId: PropTypes.string.isRequired
};